import { findApiByAction } from './findApiByAction.js';

export const appGrep = (app) => {
  const grep = {
    action: ({ actionId }) => {
      return app?.actions?.find((n) => n?.id === actionId);
    },

    actionAttributes: ({ actionId }) => {
      const action = grep.action({ actionId });
      return action?.attributes || [];
    },

    actionApi: ({ action }) => {
      return findApiByAction(app, action);
    },

    authByType: ({ type }) => {
      return app?.authentication?.find((n) => n?.type === type);
    }
  };

  return grep;
};
